import type { AllCategory } from "@app/services/category/types";
import { matchPrefixByPathname, sanitizeRoutePath } from "@app/common/utils/permissions";
import { RBAC_ACTIONS } from "@app/common/utils/permissionsConstants";

export const ROUTE_PERMISSIONS: Record<string, string> = {
  "/dispensation/drugDelivery": "medicineDelivered",
  "/dispensation/drugDelivery/eps/order": "medicineDelivered",
  "/dispensation/drugDelivery/dispensary": "medicineDelivered",
  "/dispensation/drugDelivery/dispensary/detail": "medicineDelivered",
  "/dispensation/drugDelivery/patientOrderInformation": "medicineDelivered",
  "/dispensation/drugDelivery/dispensary/detailOrder": "medicineDelivered",
  "/dispensation/deliveryAuth": "complete_delivery_medicines",
  "/dispensation/deliveryAuth/detail": "complete_delivery_medicines",
  "/dispensation/supportParameters": "tm_contract_supports",
  "/dispensation/supportParameters/create": "tm_contract_supports",
  "/dispensation/supportParameters/edit": "tm_contract_supports",
  "/dispensation/dispensarySupports": "dispensary-supports",
  "/dispensation/dispensarySupports/detail": "dispensary-supports",
  "/dispensation/dispensarySupportFiles": "review_dispensary_supports",
  "/dispensation/dispensarySupportFiles/detail": "review_dispensary_supports",
  "/dispensation/store": "store",
  "/dispensation/pendingConsults": "pending_consults",
  "/dispensation/pharmacyControl": "pharmacy_control",
  "/dispensation/pharmacyControl/detail": "pharmacy_control",
  "/dispensation/consumerOutReport": "consumer_out_report",
  "/dispensation/topInventoryOutReport": "top_consumer_out_report",
  "/dispensation/CancellationDeliveries": "requests_to_cancel_dispensation",
  "/dispensation/accountingNotes": "accounting_notes"
};

export const getRoutePermission = ({
  pathname,
  categories
}: {
  pathname: string;
  categories: AllCategory[];
}): { prefix: string; action: string } => {
  const normalizedPath = sanitizeRoutePath(pathname);

  if (!normalizedPath) {
    return { prefix: "", action: RBAC_ACTIONS.READ };
  }

  const explicitPermission = ROUTE_PERMISSIONS[normalizedPath];
  if (explicitPermission) {
    return { prefix: explicitPermission, action: RBAC_ACTIONS.READ };
  }

  return {
    prefix: matchPrefixByPathname({ pathname: normalizedPath, categories }),
    action: RBAC_ACTIONS.READ
  };
};

export const getRoutePrefix = ({
  pathname,
  categories
}: {
  pathname: string;
  categories: AllCategory[];
}): string => getRoutePermission({ pathname, categories }).prefix;
